$mol_book2 $mol_scroll
	menu_title \
	sub <= pages /$mol_view
	minimal_width 0
	Placeholder $mol_view
	Gap* $mol_view title \
